import { withRouter } from 'react-router-dom';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

import groupBy from 'lodash.groupby';

import {
  Card,
  LinearProgress,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Button,
  Grid,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { ASSETS_ROUTE } from 'Api/Routes.js';
import Slips from './components/Slips';
import Slip from './components/Slip';
import Overlay from './components/Overlay';
import Options from './components/Options';
import CriteriaImage from 'CriteriaImage';
import OpticalDistributionImage from '../../../OpticalDistributionImage';
import Tooltip from '@material-ui/core/Tooltip';
import { slipMapper } from './TicketHelper';

const CustomCard = styled(Card)`
  &&& {
    width: 100%;
    display: flex;
    margin-bottom: 1rem;
    flex-direction: column;
    flex: 0 0 auto;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover ${Overlay} {
      opacity: 0.8;
    }
  }
`;

const GridSlips = styled(Grid)`
  text-align: center;
`;

const CustomExpansionPanelSummary = styled(ExpansionPanelSummary)`
  height: 40px !important;
  &&& {
    min-height: 40px !important;
    background: #ebeded;
    border-bottom: 1px solid ${({ theme }) => theme.palette.blue.light};
    font-size: 0.875rem;
    font-weight: 600;
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.typography.headerFontFamily};
    line-height: 25px;
  }
`;

const CustomExpansionPanelDetails = styled(ExpansionPanelDetails)`
  &&& {
    padding: 0.9375rem;
  }
`;

const CustomLinearProgress = styled(LinearProgress)`
  &&& {
    border-radius: 5px;
    flex: 3;
    background: ${({ type, theme }) =>
      type === 'updated' && theme.palette.blue.main};
    ${({ type, theme }) =>
      type === 'updated' &&
      `& .MuiLinearProgress-bar1Determinate-53 {
            background: ${theme.palette.blue.light};
        }
    `};
    ${({ value }) =>
      value >= 80 &&
      `& > div {
      background-color: red !important;
    }`};
  }
`;

const ImagesContainer = styled.div`
  height: 6.25rem;
  width: 6.25rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  border: 1px solid #000;
  background: ${({ theme }) => theme.palette.gray.light};
  align-self: center;
  &::before {
    content: '';
    width: 100%;
    height: 1px;
    background: #000;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
  &::after {
    content: '';
    width: 100%;
    height: 1px;
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    transform: rotate(-90deg) translateX(-50%);
  }
`;

const ImagesWrapper = styled.div`
  background: #ebeded;
  display: flex;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 49px;
  flex: 0 0 50%;
`;
const Section = styled.div`
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-size: 0.75rem;
  padding-bottom: 5px;
  border-bottom: 1px solid grey;
  margin-bottom: 5px;
`;

const InnerContainer = styled.div`
  display: flex;
  position: relative;
`;
const ActionOnTicket = styled.div`
  display: flex;
  flex-direction: column;
`;

const CriteriaImg = styled.img`
  margin: 0;
  display: block;
  height: 100%;
`;

const Content = styled.div`
  padding: 0.5625rem;
  position: relative;
  flex: 2;
  background: #fff;
`;

const Title = styled.div`
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 0.25rem;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  color: ${({ theme, type }) =>
    type === 'updated' ? '#fff' : theme.palette.secondary.dark};
  height: 20px;
`;

const LocationOnPlan = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 220px;
  display: inline-block;
  line-height: 20px;
  vertical-align: middle;
`;

const SubTitle = styled.div`
  font-size: 0.8125rem;
  font-weight: 400;
  font-family: ${({ theme }) => theme.typography.bodyFontFamily};
  padding-top: ${({ addPadding }) => (addPadding ? '15px' : '0')};
  margin-bottom: 0.25rem;
  color: ${({ theme }) => theme.palette.secondary.main};
`;

const Desc = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  font-family: ${({ theme }) => theme.typography.bodyFontFamily};
  margin-bottom: 0.5rem;
  color: ${({ theme, type }) => theme.palette.blue.main};
`;

const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Time = styled.div`
  font-size: 0.75rem;
  color: ${({ theme, type }) =>
    type === 'updated' ? '#fff' : theme.palette.secondary.main};
  margin-left: 0.5rem;
`;

const DateCreated = styled.div`
  font-size: 0.75rem;
  color: ${({ theme, type }) =>
    type === 'updated' ? '#fff' : theme.palette.secondary.main};
  margin-right: 0.5rem;
`;

const ExpiredText = styled.div`
  font-size: 0.75rem;
  color: red;
  text-transform: uppercase;
`;

const InfoCircle = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 25px;
  width: 25px;
  border-radius: 100%;
  background-color: ${props => props.color};
  padding: 0 !important;
  text-align: center;
  justify-content: center;
  color: #fff;
  font-weight: normal;
  margin-right: 5px;
`;
const InfoField = styled.div`
  margin-right: 10px;
  display: flex;
  @media (max-width: 1450px) {
    > span {
      text-indent: -9999px;
    }
  }
`;

const ViewButton = styled(Button)`
  height: 100%;
  &&& {
    border-top-left-radius: 0%;
    border-top-right-radius: 0%;
    border-bottom-left-radius: 0%;
    border-bottom-right-radius: 0%;
    // border-color: #fff;
    border-color: #ebeded;
    // background-color: rgba(0, 0, 0, 0.12);
    background: #ebeded;
    border-bottom-color: #999a9a !important;
    color: currentColor;
    // border-left: 1px solid currentColor;
    &:hover {
      color: currentColor;
    }
  }
`;

const HideButton = styled(Button)`
  // height: 100%;
  &&& {
    border-top-left-radius: 0%;
    border-top-right-radius: 0%;
    border-bottom-left-radius: 0%;
    border-bottom-right-radius: 0%;
    // border-color: #fff;
    border-color: #ebeded;
    // background-color: rgba(0, 0, 0, 0.12);
    background: #ebeded;
    border-bottom-color: ${props =>
      props.showborder === 'true' ? '#999a9a !important' : '#ebeded'};
    color: currentColor;
    // border-left: 1px solid currentColor;
    &:hover {
      color: currentColor;
    }
  }
`;

const ShortListed = styled.div`
  padding: 1px 20px 1px 20px;
  color: white;
  background: #f44336;
  position: absolute;
  transform: rotate(35deg);
  top: 36px;
  right: -29px;
`;

class Ticket extends React.PureComponent {
  state = {
    expanded: false,
    ticket: [],
  };
  componentDidMount() {
    this.setState({
      ticket: this.props.ticket,
    });
  }

  navigateToTicket = (id, showRespondButton) => () => {
    if (!this.props.ticketViewed) {
      //if ticket is not viewed and
      this.props.addToViewedList(this.props.projectId, id);
    }
    return this.props.history.push('/supply/ticket/' + id);
  };

  navigateToSlipPreview = (id, expired, shortlisted) => () => {
    this.props.onUpdateSlipState(id);
    return this.props.history.push('/supply/slip/' + id, {
      expired,
      shortlisted,
    });
  };

  isExpanded = (_, expanded) => {
    this.setState({ expanded });
  };

  renderImages = (assets = []) => {
    return assets.map(id => {
      return (
        <ImageWrapper key={id}>
          <CriteriaImg src={`${ASSETS_ROUTE}${id}`} alt="criteria" />
        </ImageWrapper>
      );
    });
  };

  calculateRemainingTime = (created, expiration) => {
    if (created && !expiration) return null;

    const now = moment();
    const mCreated = moment(created);
    const mExpiration = moment(expiration);

    const totalMinutes = mExpiration.diff(mCreated, 'minutes');
    const remainingMinutes = mExpiration.diff(now, 'minutes');

    const days = mExpiration.diff(now, 'days');
    const hours = mExpiration.subtract(days, 'days').diff(now, 'hours');
    const minutes = mExpiration.subtract(hours, 'hours').diff(now, 'minutes');

    if (days < 0 || minutes < 0 || hours < 0) {
      return 0;
    }

    return {
      time: `${days && days > 0 ? days + 'd' : ''} ${
        hours && hours > 0 ? hours + 'h' : ''
      } ${minutes && minutes > 0 ? minutes + 'm' : ''}`,
      percentage: 100 - Math.floor((100 * remainingMinutes) / totalMinutes),
    };
  };

  render() {
    const ticket = this.state.ticket;
    const remainingTime = this.calculateRemainingTime(
      ticket.createdDate,
      ticket.validUntil
    );
    const formatedDateCreated = moment(ticket.createdDate).format('"YY-MM-DD');
    let splited = this.props.location.pathname.split('/');
    if (splited[splited.length - 2] !== 'ticket') {
      splited = Number(splited[splited.length - 1]);
    } else {
      splited === 0;
    }
    return (
      <CustomCard elevation={10}>
        <InnerContainer>
          <ImagesWrapper>
            <ImagesContainer>
              <ImageWrapper>
                <OpticalDistributionImage
                  icon={ticket.opticalDistributionCriteriaId}
                />
              </ImageWrapper>
              <ImageWrapper>
                <CriteriaImage iconCombination={ticket.ticketImageName} small />
              </ImageWrapper>
              {this.renderImages(ticket.assets)}
              {ticket.assets &&
              ticket.assets.length &&
              ticket.assets.length === 1 ? (
                <ImageWrapper />
              ) : null}
            </ImagesContainer>
          </ImagesWrapper>
          <Content>
            {ticket.hasDeletedSlip && (
              <ShortListed>updated requirement</ShortListed>
            )}
            <Title>
              <LocationOnPlan>
                <b>{`${ticket.referenceName}`} </b>
                {`${ticket.ticketName !== null ? ticket.ticketName : ''}`}
              </LocationOnPlan>
              <div
                style={{
                  float: 'right',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: 'auto',
                }}
              >
                {ticket.projectCity && <b>{ticket.projectCity},&nbsp;</b>}
                {ticket.projectCountryState && (
                  <b>{ticket.projectCountryState},&nbsp;</b>
                )}
                {ticket.projectCountry && <b>{ticket.projectCountry}</b>}
              </div>
            </Title>
            <SubTitle
              addPadding={
                ticket.primaryHierarchyCriteria &&
                ticket.primaryHierarchyCriteria.length > 15
              }
            >
              {ticket.primaryHierarchyCriteria}
            </SubTitle>
            <Desc>{ticket.secondaryHierarchyCriteria}</Desc>
            {ticket.slips && ticket.slips.length > 0 && remainingTime === 0 ? (
              <ExpiredText>expired</ExpiredText>
            ) : (
              <ProgressContainer>
                <DateCreated>{formatedDateCreated}</DateCreated>
                {remainingTime && remainingTime.percentage ? (
                  <CustomLinearProgress
                    variant="determinate"
                    value={remainingTime.percentage}
                  />
                ) : null}
                {remainingTime === 0 ? (
                  <ExpiredText>expired</ExpiredText>
                ) : null}
                {remainingTime && remainingTime.time !== 0 ? (
                  <Time>{remainingTime.time}</Time>
                ) : null}
              </ProgressContainer>
            )}
          </Content>
          <ActionOnTicket>
            <ViewButton
              onClick={this.navigateToTicket(ticket.ticketId)}
              variant="outlined"
            >
              View
            </ViewButton>
            {!ticket.isHidden && (
              <HideButton
                onClick={this.props.removeTicketFromSideBar(ticket.ticketId)}
                variant="outlined"
                showborder={
                  ticket.slips && ticket.slips.length ? 'true' : 'false'
                }
              >
                Discard
              </HideButton>
            )}
          </ActionOnTicket>
        </InnerContainer>
        {ticket.slips && ticket.slips.length && (
          <div>
            <ExpansionPanel
              onChange={() => this.setState({ expanded: !this.state.expanded })}
            >
              {/* ovo je deo gde treba da se doda archvied button */}
              <CustomExpansionPanelSummary expandIcon={<ExpandMore />}>
                <InfoField>
                  <Tooltip title="Luminaires">
                    <InfoCircle
                      color={
                        ticket.notifications.hasAnyUpdatedSlipColumnOne
                          ? '#f44336'
                          : '#37474f'
                      }
                    >
                      {ticket.notifications.numberOfNewAndViewedSlips}
                    </InfoCircle>
                  </Tooltip>
                </InfoField>
                <InfoField>
                  <Tooltip title="Matches">
                    <InfoCircle
                      color={
                        ticket.notifications.hasAnyUpdatedSlipColumnTwo
                          ? '#ffca28'
                          : '#37474f'
                      }
                    >
                      {ticket.notifications.numberOfMatchedSlips}
                    </InfoCircle>
                  </Tooltip>
                </InfoField>
                <InfoField>
                  <Tooltip title="Selections">
                    <InfoCircle
                      color={
                        ticket.notifications.hasAnyUpdatedSlipColumnThree
                          ? '#4caf50'
                          : '#37474f'
                      }
                    >
                      {ticket.notifications.numberOfDealedSlips}
                    </InfoCircle>
                  </Tooltip>
                </InfoField>
              </CustomExpansionPanelSummary>
              <CustomExpansionPanelDetails>
                <Grid container>
                  {this.state.expanded &&
                    slipMapper.map(section => (
                      <GridSlips
                        key={section.sectionName}
                        item
                        xs={section.gridSize}
                      >
                        <Section>{section.sectionName}: </Section>
                        {ticket.slips.map(
                          slip =>
                            slip.slipLevel === section.slipLevel && (
                              <Slips key={slip.slipId}>
                                <Slip
                                  name={slip.slipName}
                                  shortlisted={slip.slipLevel === 2}
                                  onSlipSelect={this.navigateToSlipPreview(
                                    slip.slipId,
                                    remainingTime === 0,
                                    slip.slipLevel === 2
                                  )}
                                  selected={slip.slipId === splited}
                                  discarded={slip.slipLevel === 0}
                                  deal={slip.slipLevel === 3}
                                  archived={slip.slipLevel === 4}
                                  updated={slip.updatedBySupplier}
                                  drafted={slip.drafted}
                                />
                              </Slips>
                            )
                        )}
                      </GridSlips>
                    ))}
                </Grid>
              </CustomExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        )}
      </CustomCard>
    );
  }
}

export default withRouter(Ticket);
